import { render, staticRenderFns } from "./UpUpass.vue?vue&type=template&id=e3193aae&scoped=true"
import script from "./UpUpass.vue?vue&type=script&lang=js"
export * from "./UpUpass.vue?vue&type=script&lang=js"
import style0 from "./UpUpass.vue?vue&type=style&index=0&id=e3193aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3193aae",
  null
  
)

export default component.exports